import React from 'react';
import { PRIVACY_POLICY_CONTENT } from '@court-sync/shared';
import Footer from '../components/Footer';

export default function Privacy() {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container mx-auto px-4 py-16 max-w-4xl">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
            Privacy Policy
          </h1>
          <div className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
            <p>Version {PRIVACY_POLICY_CONTENT.version}</p>
            <p>Last Updated: {PRIVACY_POLICY_CONTENT.lastUpdated}</p>
          </div>
        </div>

        {/* Content */}
        <article className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
          {PRIVACY_POLICY_CONTENT.sections.map((section, index) => (
            <section key={index} className="mb-8 last:mb-0">
              <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">
                {section.title}
              </h2>
              <div className="text-gray-700 dark:text-gray-300 whitespace-pre-line leading-relaxed">
                {section.content}
              </div>
            </section>
          ))}
        </article>

        {/* Footer Note */}
        <div className="mt-8 pt-8 border-t border-gray-200 dark:border-gray-700">
          <p className="text-sm text-gray-600 dark:text-gray-400">
            If you have any questions about this Privacy Policy, please contact us at{' '}
            <a
              href="mailto:privacy@courtsync.io"
              className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 underline"
            >
              privacy@courtsync.io
            </a>
            .
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
